import { noSelectionKey } from '../../../../../utilities/filterAndSortingsUtil';

function isCommandDisabled(selectedKey) {
  return !selectedKey || selectedKey === noSelectionKey;
}

export function getCommandBarItems(
  translator,
  selectedHearingTypeKey,
  onUpdateButtonPress,
) {
  return [
    {
      key: 'updateInvitationGroupMappings',
      name: translator('pages.adminInvitationGroups.updateButton'),
      iconProps: {
        iconName: 'Edit',
      },
      onClick: onUpdateButtonPress,
      disabled: isCommandDisabled(selectedHearingTypeKey),
      buttonStyles,
    },
  ];
}

const buttonStyles = {
  root: {
    backgroundColor: '#FAFAFA',
  },
  rootDisabled: {
    backgroundColor: '#FAFAFA',
  },
};
